'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var SimpleInput = require('./SimpleInput.js');

var Input = react.forwardRef(function (_a, ref) {
    var hideLabel = _a.hideLabel, onBlur = _a.onBlur, onFocus = _a.onFocus, onChange = _a.onChange, _b = _a.value, value = _b === void 0 ? '' : _b, setValue = _a.setValue, error = _a.error, setError = _a.setError, label = _a.label, validator = _a.validator, props = tslib.__rest(_a, ["hideLabel", "onBlur", "onFocus", "onChange", "value", "setValue", "error", "setError", "label", "validator"]);
    var _c = useDefaultInternalState.default(value, setValue), valueState = _c[0], setValueState = _c[1];
    var _d = useDefaultInternalState.default(error, setError), errorState = _d[0], setErrorState = _d[1];
    var blurHandler = function (e) {
        if (validator) {
            var result = validator(e.target.value);
            setErrorState(result);
        }
        else {
            setErrorState();
        }
        if (onBlur) {
            onBlur(e); //Invoking onBlur function - allows you to use function when creating new inputs
        }
    };
    var focusHandler = function (e) {
        setErrorState(null);
        if (onFocus) {
            onFocus(e); //Invoking onFocus function - allows you to use function when creating new inputs
        }
    };
    var changeHandler = function (e) {
        var newVal = e.target.value;
        setValueState(newVal);
        if (onChange) {
            onChange(e);
        }
    };
    return (jsxRuntime.jsx(SimpleInput.default, tslib.__assign({ onBlur: blurHandler, onFocus: focusHandler, onChange: changeHandler, error: errorState, label: label, hideLabel: hideLabel, ref: ref, value: valueState }, props)));
});
Input.displayName = 'Input';
var Input$1 = Input;

exports.default = Input$1;
//# sourceMappingURL=Input.js.map
